import { getRecommendedApiName } from 'self-service-api/api/getRecommendedApiName';
import { MARKETING_HUB_STARTER } from 'self-service-api/constants/ApiNames';
import { RECOMMENDED_HUB } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
export const FetchRecommendedHubRequestTypes = createRequestTypes(RECOMMENDED_HUB);
export const FetchRecommendedHubActions = createRequestActions(FetchRecommendedHubRequestTypes);
export const fetchRecommendedHub = () => makeFetchRequest({
  requestActions: FetchRecommendedHubActions,
  fetch: () => getRecommendedApiName({
    fallbackApiName: MARKETING_HUB_STARTER
  })
});